import React, { useState, useContext } from "react";
import { HttpService } from "../../apiAuthorization/httpService";
import { Context } from "../contexts/siteContext"
import { LoadOfflineDatas } from '../../offline/dataService/offlineData';

export const Modules = React.createContext(null);

export const ModuleContext = props => {
    const { defaultSite } = useContext(Context);
    const [modules, setModules] = useState([]);
    const [trainingModules, setTrainingModules] = useState([]);
    const [showTraining, setShowTraining] = useState(false);
    const [trainingMode, setTrainingMode] = useState(false);

    const getUserModules = (personId) => {
        HttpService.post("/Home/GetUserModules")
        .then((result) => {
            setModules(result);
            if (defaultSite && defaultSite.id) {
                LoadOfflineDatas(defaultSite, result, true, personId);
            }
        },
        (error) => {
            console.log(error);
        })
    };

    const getTrainingModules = () => {
        HttpService.post("/Home/GetTrainingModules")
            .then((result) => {
                if (result && (result.error || result.offline)) {
                    return;
                }

                setTrainingModules(result.data);
                if (result.data.length > 0) {
                    setShowTraining(true);
                }
            },
                (error) => {
                    console.log(error);
                })
    };

    return (
        <>
            <Modules.Provider value={{ modules, getUserModules, setModules, trainingModules, getTrainingModules, showTraining, trainingMode, setTrainingMode }}>
                {props.children}
            </Modules.Provider>
        </>
    );
}
